import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useRootDispatch, useRootSelector } from '../../../../store/hooks';
import { selectSiteHeader } from '../../../../store/features/siteHeader';
import { selectSiteContent } from '../../../../store/features/siteContent';
import {
  fetchFestivalProGuests,
  selectFestivalProGuestById,
  selectFestivalProGuestsStatus,
} from '../../../../store/features/festivalProGuests';
import {
  fetchFestivalProGuestSchedule,
  selectFestivalProSchedule,
} from '../../../../store/features/festivalProSchedule';
import s from './FestivalProGuestProfileView.module.scss';
import SiteLayout from '../../../layouts/SiteLayout/SiteLayout';
import GuestProfile from './GuestProfile';
import BuyExperiences from './BuyExperiences';
import NotFoundSection from '../../../siteBaseSections/NotFoundSection/NotFoundSection';
import Spinner from '../FestivalProGuestsView/Spinner';
import ExternalError from '../FestivalProGuestsView/ExternalError';

function getPricingByCurrency(pricing, currency) {
  return Object.keys(pricing).reduce((acc, key) => {
    acc[key] = pricing[key].filter((item) => item.currency === currency);
    return acc;
  }, {});
}

export default function FestivalProGuestProfileView() {
  const dispatch = useRootDispatch();
  const { guestId } = useParams();
  const {
    data: { festivalProEventId: eventId },
  } = useRootSelector(selectSiteHeader);
  const {
    details: { currency, showSchedule, showBuyExperiences },
  } = useRootSelector(selectSiteContent);
  const guest = useRootSelector(selectFestivalProGuestById(guestId));
  const guestsStatus = useRootSelector(selectFestivalProGuestsStatus);
  const schedule = useRootSelector(selectFestivalProSchedule);

  useEffect(() => {
    dispatch(fetchFestivalProGuests({ eventId }));

    if (showSchedule) {
      dispatch(fetchFestivalProGuestSchedule({ eventId, guestId }));
    }
  }, [dispatch, eventId, guestId, showSchedule]);

  const loading = guestsStatus === 'pending';
  const showError = guestsStatus === 'rejected';
  const show404 = guestsStatus === 'fulfilled' && !guest;
  const showContent = guestsStatus === 'fulfilled' && guest;

  return (
    <SiteLayout>
      {loading && <Spinner />}
      {show404 && <NotFoundSection />}
      {showError && <ExternalError />}
      {showContent && (
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <div className={s.wrapper}>
                <GuestProfile
                  guest={guest}
                  pricing={getPricingByCurrency(guest.pricing, currency)}
                  schedule={schedule}
                  showSchedule={showSchedule}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {showBuyExperiences && guest?.experiences.length > 0 && (
        <BuyExperiences experiences={guest.experiences} />
      )}
    </SiteLayout>
  );
}
